/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerService = {
  /**
   * Get Screen data
   *
   * */
  async getCustomerByCustomerCode(Code) {
    var requestScreenData = {
      url: "api/InvoiceList",
      filter: `CustomerCode eq '${Code}'`
    }
    return await ApiService.oDataGet(requestScreenData);
  },
  async getByCode(code, select, expand) {
    const requestScreenData = {
      url: "api/Customer",
      top: "1",
      filter: `Code eq '${code}'`,
      select: select ? select : undefined,
      expand: expand ? expand : undefined,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getAllCustomer() {
    const requestScreenData = {
      url: "api/CustomerList",
      select: ["Code", "Name", "CurrencyCode"],
      orderby: "Name asc",
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async saveCustomer(mode, payload) {
    var url = "api/Save_Customer";

    if (mode == "create") {
      return await ApiService.post(url, payload, "String");
    } else {
      return await ApiService.put(url, payload.Code, payload, "String");
    }
  },
  async getTotalOutStandingValue(params) {
    params.url = "api/CustomerAging";
    return await ApiService.oDataGet(params);
  },
  async getSalesRepForCustomer(customer_id) {
    const requestScreenData = {
      url: "api/Customer",
      top: "1",
      filter: `Code eq '${customer_id}'`,
      select: ['SalesRepresentativeCode']
    };

    return await ApiService.oDataGet(requestScreenData);

  },

  async getCustomerData(filter) {

    const requestScreenData = {
      url: "api/Customer",
      top: "1",
      filter: filter,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getActiveTransactions(params) {

    const requestScreenData = {
      url: "api/CustomerActiveTransactions",
      top: "1",
      filter: params.filter,
      select: params.select
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async saveCustomerWithContact(payload) {
    var url = "api/Save_Customer/CustomerWithContact";

    return await ApiService.post(url, payload, "String");
  },
  
  async getByRecordId(RecordId, select) {
    const requestScreenData = {
      url: "api/Customer",
      top: "1",
      filter: `RecordId eq ${RecordId}`,
      select: select ? select : undefined,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { CustomerService };
